import styled from 'styled-components';

const StyledBannerImage = styled.img`
  height: 540px;
  width: 100%;
  object-fit: cover;
  margin-top: 2rem;
`;

const StyledImage = styled.img`
  border-radius: ${(props) => props.theme.radius.md};
`;

export { StyledBannerImage, StyledImage };
